import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {injectIntl, intlShape} from 'react-intl';

import {onSocialClick} from '../utils/socials';

const MAX_ITEMS = 5;

class SecondarySocials extends Component {
  splitSocials() {
    const {allowedSocials, shownCount, hiddenSocials} = this.props;

    const count =
      Math.min(shownCount, MAX_ITEMS) -
      (allowedSocials.length + hiddenSocials.length > MAX_ITEMS ? 1 : 0);

    return {
      shownSocials: allowedSocials.slice(0, count),
      hiddenSocials: [...allowedSocials.slice(count), ...hiddenSocials]
    };
  }

  render() {
    const {
      intl,
      otherSocialLink,
      xl: {externalWindow},
      auth,
      dispatch
    } = this.props;

    const {shownSocials, hiddenSocials} = this.splitSocials();

    const isRedirecting = auth.login.loading || auth.registration.loading;

    return (
      <div className="secondary-socials">
        <ul>
          {shownSocials.map((item, index) => {
            // eslint-disable-next-line no-param-reassign
            item.label = intl.messages[`socials.${item.name}`] || item.name;

            return (
              <li
                key={index}
                onClick={() =>
                  !isRedirecting &&
                  onSocialClick({
                    url: item.url,
                    label: item.label,
                    dispatch,
                    intl,
                    externalWindow
                  })
                }
              >
                <div className="tooltip">
                  {intl.formatMessage(
                    {id: 'socials.sign-in-with'},
                    {name: intl.messages[`socials.${item.name}`] || item.name}
                  )}
                </div>
                <div className={`icon social-${item.name}`}>{item.label}</div>
              </li>
            );
          })}

          {hiddenSocials.length > 0 && (
            <li key="secondary-other" className="social-other">
              <Link
                className="icon social-other"
                to={
                  !isRedirecting
                    ? {pathname: otherSocialLink, search: this.context.location.search}
                    : {
                        pathname: this.context.location.pathname,
                        search: this.context.location.search
                      }
                }
              >
                other
              </Link>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

SecondarySocials.propTypes = {
  allowedSocials: PropTypes.array,
  shownCount: PropTypes.number,
  hiddenSocials: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  xl: PropTypes.object.isRequired,
  intl: intlShape,
  otherSocialLink: PropTypes.string.isRequired,
  auth: PropTypes.object.isRequired
};

SecondarySocials.defaultProps = {
  allowedSocials: [],
  shownCount: MAX_ITEMS,
  hiddenSocials: []
};

SecondarySocials.contextTypes = {
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    ...state
  };
}

export default injectIntl(connect(mapStateToProps)(SecondarySocials));



// WEBPACK FOOTER //
// ./components/SecondarySocials.jsx